import React, { useEffect, useState } from 'react';
import SeperateChatPreview from './SeparateChat';
import { goApi } from '../../services';
import { LoadingSection } from '../../common/LoadingSection';

const LiveClassPreview = ({ scheduleId }: any) => {
    const [schedule, setSchedule] = useState<any>(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    // useEffect(() => {
    //     if (!scheduleId) return;
    //     const fetchSchedule = async () => {
    //         try {
    //             setLoading(true);
    //             const res = await goApi?.get(`/batches/schedules/${scheduleId}`);
    //             setSchedule(res.data);
    //         } catch (err: any) {
    //             setError(err.message || 'Failed to load schedule');
    //         } finally {
    //             setLoading(false);
    //         }
    //     };

    //     fetchSchedule();
    // }, [scheduleId]);
    return (
        <div className="flex flex-row">
            <div className="w-2/3">
                <SeperateChatPreview batchScheduleId={scheduleId} topHeight="200px" />
            </div>
            {loading ? (
                <LoadingSection />
            ) : error ? (
                <div className="text-red-500">{error}</div>
            ) : (
                <div>
                    <div className={'w-full h-auto flex-col flex'}>
                        <div className={' aspect-video bg-zinc-500 rounded-md'} />
                        <a
                            href={`#/batch_schedules/${scheduleId}/chat`}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="mt-5 pt-5 text-blue-700 underline text-xl"
                        >
                            Separate Chat Window
                        </a>
                    </div>
                </div>
            )}
        </div>
    );
};

export default LiveClassPreview;
